import { render, staticRenderFns } from "./MyNextMove.vue?vue&type=template&id=597fdcfc&scoped=true"
import script from "./MyNextMove.vue?vue&type=script&lang=ts"
export * from "./MyNextMove.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597fdcfc",
  null
  
)

export default component.exports